import { axios } from '../utilities/axios';

const baseUrl = '/core/user-account/api/v1/user-account';

export default class UserAccountService {
  static forgotPassword(emailAddress) {
    const endpoint = `${process.env.CVNA_APP_KONG_URL}${baseUrl}/reset-password-email`;
    return axios.post(endpoint, emailAddress);
  }

  static resetPassword(userCredentials) {
    const endpoint = `${process.env.CVNA_APP_KONG_URL}${baseUrl}/reset-password`;
    return axios.post(endpoint, userCredentials);
  }
}
